<form *ngIf="isLoaded" [formGroup]="projectFormGroup" (ngSubmit)="saveProject()" class="modal-wrapper">
    <div class="modal-header">
        <h2 *ngIf="!isUpdate" class="modal-title" id="exampleModalLabel">
            New project
        </h2>
        <h2 *ngIf="isUpdate" class="modal-title" id="exampleModalLabel">
            Edit project
        </h2>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <!-- ═══════════════════════════════════════════ -->
        <!-- SECTION: General Information                -->
        <!-- ═══════════════════════════════════════════ -->
        <section>
            <div class="sectiontitle sectiontitle--first">General information</div>

            <div class="form-group required m-b-2">
                <label>Title</label>
                <input type="text" formControlName="title" (focus)="hideErrorMessage()" trim="blur" #focussed />
                <mat-error class="error-message"
                    *ngIf="projectFormGroup.get('title').hasError('projectTitleAlreadyExists')">
                    Another project with this title already <strong>exists</strong>
                </mat-error>
                <span class="form-error"
                    *ngIf="!isUpdate && projectFormGroup.controls.title.errors && inputIsWrong">Title is required</span>
                <span class="form-error"
                    *ngIf="projectFormGroup.get('title').hasError('required') && projectFormGroup.get('title').touched">Title
                    is required</span>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="form-group required m-b-2">
                        <label>Project type</label>
                        <select formControlName="projectType" (focus)="hideErrorMessage()">
                            <option [ngValue]="0">Custom</option>
                            <option [ngValue]="1">Website</option>
                            <option [ngValue]="2">Consultancy</option>
                            <option [ngValue]="3">Other</option>
                            <option [ngValue]="4">Hosting</option>
                            <option [ngValue]="5">Intern</option>
                        </select>
                        <span class="form-error" *ngIf="projectFormGroup.controls.projectType.errors && inputIsWrong">Project type is required</span>
                    </div>
                </div>
                <div class="col-6">
                    <app-global-autocomplete *ngIf="jiraProjectKeysLoaded" [parentForm]="projectFormGroup" [formControlName]="'jiraProjectKey'"
                        [data]="jiraProjectOptions" [itemType]="null" [label]="'Jira Project Key'"
                        [notFoundMessage]="'No Jira project key found'" [keyword]="'searchLabel'" [placeholder]="'Choose Jira project key'"
                        [dataLoaded]="jiraProjectKeysLoaded" [active]="true" [required]="false" [canAdd]="false"></app-global-autocomplete>
                    <div class="form-group m-b-2" *ngIf="!jiraProjectKeysLoaded">
                        <label>Jira Project Key</label>
                        <div class="hint">Loading project keys...</div>
                    </div>
                </div>
            </div>

            <div class="form-group m-b-2">
                <label>Description</label>
                <textarea class="resize-vertical" formControlName="description" (keyup)="onDescriptionKeyUp()"
                    (focus)="hideErrorMessage()" trim="blur"></textarea>
                <small><span *ngIf="currentAmountOfDescriptionCharacters == null">0</span>{{
                    currentAmountOfDescriptionCharacters }} /{{
                    DESCRIPTION_MAX_LENGTH
                    }}</small>
                <span class="form-error" *ngIf="descriptionIsTooLong">Description cannot contain more than 1000
                    characters</span>
            </div>
        </section>

        <!-- ═══════════════════════════════════════════ -->
        <!-- SECTION: Dates & Status                     -->
        <!-- ═══════════════════════════════════════════ -->
        <section>
            <div class="m-t-4 m-b-2 sectiontitle">Dates &amp; status</div>

            <div class="row m-b-2">
                <div class="col-6">
                    <div class="form-group--toggle">
                        <label><input type="checkbox" formControlName="billable" /> Billable</label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group--toggle">
                        <label><input type="checkbox" formControlName="present" (change)="onPresentTicked()" /> No end date</label>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="form-group required m-b-2">
                        <label>Start date</label>
                        <input type="date" formControlName="startDate" />
                        <span class="form-error" *ngIf="!isValidDate && inputIsWrong">Start date must be before end date</span>
                        <span class="form-error" *ngIf="projectFormGroup.controls.startDate.errors && inputIsWrong">Start date required</span>
                        <span class="form-error"
                            *ngIf="projectFormGroup.get('startDate').hasError('required') && projectFormGroup.get('startDate').touched">Start date is required</span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group m-b-2" [class.required]="!present">
                        <label>End date</label>
                        <input type="date" formControlName="endDate" />
                        <span class="form-error" *ngIf="!isValidDate && inputIsWrong">End date must be after start date</span>
                        <span class="form-error"
                            *ngIf="projectFormGroup.get('endDate').hasError('required') && projectFormGroup.get('endDate').touched">End date required</span>
                    </div>
                </div>
            </div>

            <div class="form-group--toggle m-b-2" [class.required]="warranty">
                <label><input type="checkbox" formControlName="warranty" (change)="onWarrantyTicked()" /> Warranty</label>
            </div>
            <div class="row" *ngIf="!isHiddenControl">
                <div class="col-6">
                    <div class="form-group m-b-2" [class.required]="warranty">
                        <label>Warranty start date</label>
                        <input type="date" formControlName="warrantyStartDate" />
                        <span class="form-error"
                            *ngIf="projectFormGroup.controls.warrantyStartDate.errors && inputIsWrong">Start date required</span>
                        <span class="form-error"
                            *ngIf="projectFormGroup.get('warrantyStartDate').hasError('required') && projectFormGroup.get('warrantyStartDate').touched">Start date is required</span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group m-b-2" [class.required]="warranty">
                        <label>Warranty end date</label>
                        <input type="date" formControlName="warrantyEndDate" />
                        <span class="form-error" *ngIf="!isValidWarrantyDate && inputIsWrong">End date must be after start date</span>
                        <span class="form-error"
                            *ngIf="projectFormGroup.get('warrantyEndDate').hasError('required') && projectFormGroup.get('warrantyEndDate').touched">End date required</span>
                    </div>
                </div>
            </div>

            <div class="form-group--toggle m-b-2" [class.required]="maintenanceContract">
                <label><input type="checkbox" formControlName="maintenanceContract" (change)="onMaintenanceTicked()" /> Maintenance contract</label>
            </div>

            <div class="form-group--toggle m-b-2" *ngIf="isUpdate">
                <label><input type="checkbox" [checked]="isFinished" (change)="toggleFinished()" /> Project finished</label>
            </div>
        </section>

        <!-- ═══════════════════════════════════════════ -->
        <!-- SECTION: Location                           -->
        <!-- ═══════════════════════════════════════════ -->
        <section>
            <div class="m-t-4 m-b-2 sectiontitle">Location</div>

            <div formGroupName="location">
                <small class="form-text text-muted m-b-1" *ngIf="isCoManageAddressLocked">
                    Address fields are locked because a CoManage customer is selected.
                </small>
                <div class="row m-b-2">
                    <div class="col-6">
                        <div class="form-group">
                            <label>Street</label>
                            <input type="text" placeholder="Street" formControlName="street" (focus)="hideErrorMessage()" trim="blur" />
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group">
                            <label>Number</label>
                            <input type="number" placeholder="Nr." formControlName="number" (focus)="hideErrorMessage()" />
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group">
                            <label>Box</label>
                            <input type="text" placeholder="Box" formControlName="bus" trim="blur" />
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group">
                            <label>Ext</label>
                            <input type="number" placeholder="Ext" formControlName="ext" />
                        </div>
                    </div>
                </div>

                <div class="row m-b-2">
                    <div class="col-3">
                        <div class="form-group">
                            <label>Zip code</label>
                            <input type="text" placeholder="Zip code" formControlName="postal" (focus)="hideErrorMessage()" trim="blur" />
                        </div>
                    </div>
                    <div class="col-9">
                        <div class="form-group">
                            <label>City</label>
                            <input type="text" placeholder="City" formControlName="city" (focus)="hideErrorMessage()" trim="blur" />
                        </div>
                    </div>
                </div>

                <div class="form-group m-b-2" formGroupName="country">
                    <label>Country</label>
                    <select formControlName="iso2" (focus)="hideErrorMessage()">
                        <option *ngFor="let country of allCountries" [ngValue]="country['alpha-2']">
                            {{ country.name }}
                        </option>
                    </select>
                </div>
            </div>
        </section>

        <!-- ═══════════════════════════════════════════ -->
        <!-- SECTION: Linked Entities                    -->
        <!-- ═══════════════════════════════════════════ -->
        <section>
            <div class="m-t-4 m-b-2 sectiontitle">Linked entities</div>

            <div class="form-group m-b-2">
                <app-global-autocomplete [parentForm]="projectFormGroup" [formControlName]="'partner'" [data]="allPartners"
                    [itemType]="'company'" [label]="'Company'" [notFoundMessage]="'Add a company'"
                    [keyword]="partnerKeyword" [placeholder]="'Choose company'" [dataLoaded]="isLoaded"
                    [active]="moduleService.checkModuleActive(eModule.PARTNERS)"
                    [required]="false"></app-global-autocomplete>
            </div>

            <div class="form-group m-b-2">
                <app-global-autocomplete [parentForm]="projectFormGroup" [formControlName]="'customer'"
                    [data]="allCustomers" [itemType]="'customer'" [label]="'Customer'"
                    [notFoundMessage]="'Add a customer'" [keyword]="'firstName'" [placeholder]="'Choose customer'"
                    [dataLoaded]="isLoaded" [active]="this.moduleService.checkModuleActive(eModule.CUSTOMERS)"
                    [required]="false"></app-global-autocomplete>
            </div>

            <div class="form-group m-b-2">
                <app-global-autocomplete [parentForm]="projectFormGroup" [formControlName]="'comanageCustomer'"
                    [data]="coManageCustomerOptions" [itemType]="null" [label]="'Comanage contact'"
                    [notFoundMessage]="'No CoManage contact found'" [keyword]="'searchLabel'" [placeholder]="'Choose Comanage contact'"
                    [dataLoaded]="isLoaded" [active]="this.moduleService.checkModuleActive(eModule.COMANAGE)"
                    [required]="false" [canAdd]="false"></app-global-autocomplete>
            </div>

            <div class="form-group m-b-2">
                <app-global-autocomplete [parentForm]="projectFormGroup" [formControlName]="'contact'"
                    [data]="getRelevantContacts()" [itemType]="'contact'" [label]="'Contact person'"
                    [notFoundMessage]="'Add a contact'" [keyword]="'firstName'" [placeholder]="'Choose contact'"
                    [dataLoaded]="isLoaded" [active]="this.moduleService.checkModuleActive(eModule.CONTACTS)"
                    [required]="false"></app-global-autocomplete>
            </div>

            <div class="form-group m-b-2">
                <label>Business developer</label>
                <select formControlName="businessDeveloperUuid">
                    <option [ngValue]="null">Choose business developer</option>
                    <option *ngFor="let employee of allEmployees" [ngValue]="employee.uuid">{{ employeeName(employee) }}</option>
                </select>
            </div>
        </section>

        <!-- ═══════════════════════════════════════════ -->
        <!-- SECTION: Invoicing & Comanage               -->
        <!-- ═══════════════════════════════════════════ -->
        <section>
            <div class="m-t-4 m-b-2 sectiontitle">Invoicing</div>

            <div class="row m-b-2">
                <div class="col-12">
                    <div class="form-group">
                        <label>Document from Files (for AI prefill)</label>
                        <div class="d-flex" style="gap: 8px; align-items: center;">
                            <select [(ngModel)]="selectedProjectDocumentId" [ngModelOptions]="{ standalone: true }" [style.flex]="1">
                            <option [ngValue]="null">Choose document from Files tab</option>
                            <option *ngFor="let document of projectDocuments" [ngValue]="document.fileId">{{ getDocumentDisplayName(document) }}</option>
                            </select>
                            <button type="button" class="button button--outline button--small" (click)="refreshProjectDocuments()">Refresh</button>
                        </div>
                        <button
                            type="button"
                            class="button button--icon m-t-1"
                            [disabled]="aiExtractingProjectSettings || !selectedProjectDocumentId"
                            (click)="extractProjectSettingsWithAi()">
                            <i class="las la-magic" aria-hidden="true"></i>
                            <span>{{ aiExtractingProjectSettings ? 'Extracting…' : 'AI extract invoicing & time registration' }}</span>
                        </button>
                        <small class="form-text text-muted">Select a document from this project's Files tab; AI uses that PDF to prefill invoicing and time registration fields below.</small>
                        <small class="form-text text-muted" *ngIf="!projectDocuments?.length">No linked Files documents found for this project. Use Refresh after linking a file in the Files tab.</small>
                    </div>
                </div>
            </div>

            <div class="row m-b-2">
                <div class="col-4">
                    <div class="form-group">
                        <label>Invoice method</label>
                        <select formControlName="invoiceMethod">
                            <option [ngValue]="'BY_TIME'">By time</option>
                            <option [ngValue]="'BY_ACCOUNT'">By account</option>
                            <option [ngValue]="'BY_SES'">By SES</option>
                        </select>
                        <small class="form-text text-muted">Default: consultancy by time, custom/other by account.</small>
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group--toggle">
                        <label><input type="checkbox" formControlName="invoiceByDay" /> Invoice per day</label>
                        <small class="form-text text-muted">Instead of per hour (1 day = 8h default).</small>
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group--toggle">
                        <label><input type="checkbox" formControlName="poRequired" /> PO number required</label>
                        <small class="form-text text-muted">Require a PO number before creating invoices.</small>
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group--toggle">
                        <label><input type="checkbox" formControlName="sesRequired" /> SES number required</label>
                        <small class="form-text text-muted">Require a SES number before creating invoices.</small>
                    </div>
                </div>
                <div class="col-4" *ngIf="projectFormGroup.get('invoiceByDay').value">
                    <div class="form-group">
                        <label>Hours per day</label>
                        <input type="number" formControlName="hoursPerDay" placeholder="e.g. 8" min="1" max="12" step="0.5" />
                        <small class="form-text text-muted">For AI hour validation only.</small>
                        <span class="form-error"
                            *ngIf="projectFormGroup.get('hoursPerDay').hasError('min') || projectFormGroup.get('hoursPerDay').hasError('max')">
                            Enter a value between 1 and 12.
                        </span>
                    </div>
                </div>
            </div>

            <div class="row m-b-2">
                <div class="col-4">
                    <div class="form-group">
                        <label>Payment term (days)</label>
                        <input type="number" formControlName="paymentTermDays" placeholder="30" min="1" max="180" />
                        <small class="form-text text-muted">Used when creating invoices (default 30).</small>
                    </div>
                </div>
            </div>
        </section>

        <!-- ═══════════════════════════════════════════ -->
        <!-- SECTION: Research & Development             -->
        <!-- ═══════════════════════════════════════════ -->
        <section>
            <div class="m-t-4 m-b-2 sectiontitle">Onderzoek en ontwikkeling</div>

            <div class="row m-b-2">
                <div class="col-6">
                    <div class="form-group--toggle">
                        <label><input type="checkbox" formControlName="researchDevelopmentEligible" /> Komt in aanmerking voor O&amp;O</label>
                    </div>
                </div>
                <div class="col-6" *ngIf="projectFormGroup.get('researchDevelopmentEligible').value">
                    <div class="form-group required">
                        <label>O&amp;O percentage</label>
                        <input type="number" formControlName="researchDevelopmentPercentage" min="0" max="100" step="0.01" />
                        <span class="form-error"
                            *ngIf="projectFormGroup.get('researchDevelopmentPercentage').invalid && projectFormGroup.get('researchDevelopmentPercentage').touched">
                            Enter a percentage between 0 and 100.
                        </span>
                    </div>
                </div>
            </div>
        </section>

        <!-- ═══════════════════════════════════════════ -->
        <!-- SECTION: Time Registration                  -->
        <!-- ═══════════════════════════════════════════ -->
        <section>
            <div class="m-t-4 m-b-2 sectiontitle">Time registration</div>

            <div class="form-group--toggle m-b-2">
                <label><input type="checkbox" formControlName="timesheetRequired" /> Time registration required</label>
            </div>

            <div class="form-group m-b-2">
                <label>Registration type</label>
                <input type="text" formControlName="timesheetType" placeholder="e.g. Tempo, internal, client…" />
                <span class="form-error"
                    *ngIf="projectFormGroup.get('timesheetType').hasError('required') && projectFormGroup.get('timesheetRequired').value">
                    Registration type is required.
                </span>
                <div class="alert alert-success m-t-1"
                    *ngIf="projectFormGroup.get('timesheetRequired').value && projectFormGroup.get('timesheetType').value">
                    Time registration is required and a type is selected.
                </div>
                <div class="alert alert-info m-t-1"
                    *ngIf="!projectFormGroup.get('timesheetRequired').value">
                    Time registration is not required for this project (informational).
                </div>
            </div>

            <div class="form-group--toggle m-b-2"
                *ngIf="projectFormGroup.get('timesheetRequired').value">
                <label>
                    <input
                        type="checkbox"
                        formControlName="signedTimesheetRequired"
                        [disabled]="!projectFormGroup.get('timesheetType').value" />
                    Signed timesheet required
                </label>
                <small class="form-text text-muted">Only applies when time registration is required and a registration type is set.</small>
            </div>
        </section>

        <!-- ═══════════════════════════════════════════ -->
        <!-- SECTION: Tags                               -->
        <!-- ═══════════════════════════════════════════ -->
        <section>
            <div class="m-t-4 m-b-2 sectiontitle">Tags</div>
            <div class="form-group m-b-2">
                <app-global-tags *ngIf="!isUpdate" [type]="'project'"></app-global-tags>
                <app-global-tags *ngIf="isUpdate" [objectUuid]="this.project.uuid" [type]="'project'"></app-global-tags>
            </div>
        </section>
    </div>
    <!--
    <div *ngIf="project.products && this.moduleService.checkModuleActive('PRODUCTS')">
        <div class="sectiontitle">
            Related products
        </div>
        <table class="table-view">
            <tr>
                <th>Product</th>
                <th class="td-small"></th>
            </tr>

            <tr *ngFor="let product of project.products">
                <td>
                    <span placement="top" [ngbTooltip]="product.description">{{product.title}}</span>
                </td>
                <td>
                    <span ngbDropdown class="dropdown">
                        <button ngbDropdownToggle class="button button--icon button--small dropdown-toggle" id="dropdownMenuButton">
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="dropdownMenuButton">
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item color--red" (click)="openprojectProductDeleteModal(project, product)">Remove product</a>
                        </div>
                    </span>
                </td>
            </tr>
            <tr>
                <td colspan="3" class="table-view__add" (click)="openprojectAddProductModal(project)">
                    <i class="las la-plus"></i> Add new product
                </td>
            </tr>
        </table>
    </div>-->

    <div class="modal-footer">
        <button type="button" class="button button--outline" (click)="activeModal.close()">
            Close
        </button>
        <button *ngIf="!isUpdate" type="submit" [ngClass]="{ 'button--loading': loading }"
            class="button button--primary">
            Add project
        </button>
        <button *ngIf="isUpdate" type="submit" [ngClass]="{ 'button--loading': loading }" class="button button--primary"
            [disabled]="!projectFormGroup.valid">
            Edit project
        </button>
    </div>
</form>

<app-loading-message *ngIf="!isLoaded"></app-loading-message>
